// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","cover-wrapper":"Header_cover-wrapper__RnysS","cover":"Header_cover__hR43l","logo-wrapper":"Header_logo-wrapper__nhCYH"};